import {scrollElementIntoViewById} from '~library/utils/misc';

export const scrollEventTitleModuleIntoView = () => scrollElementIntoViewById('event-title-module');
export const scrollEventDetailsModuleIntoView = () =>
  scrollElementIntoViewById('event-details-module');
